import axios from "axios";
import { sendNotification } from "../_notificationSettings/notificationPanel";

export function PostData(BaseURL, userData, type) {
  return new Promise((resolve, reject) => {
    axios({
      method: type.toLowerCase(), // axios expects lowercase method
      url: BaseURL,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: type !== "GET" ? userData : undefined, // GET requests don’t have body
    })
      .then((res) => {
        resolve(res.data); // axios already parses JSON
      })
      .catch((error) => {
        if (error.response) {
          // server responded with a status other than 2xx
          const errorMsg = error.response.data?.message || error.response.statusText || "Server error";
          sendNotification("Error Message 😓", String(errorMsg), "danger");
          console.log("Error response", error.response);
          reject({
            message: errorMsg,
            status: error.response.status,
            data: error.response.data,
          });
        } else if (error.request) {
          // request was made but no response
          sendNotification("Error Message 😓", "API server is not reachable. Please try again later.", "danger");
          console.log("Error request", error.request);
          reject({ message: "API server not reachable" });
        } else {
          // something else happened
          const errorMsg = error.message || "Unknown error occurred";
          sendNotification("Error Message 😓", String(errorMsg), "danger");
          console.log("Error", errorMsg);
          reject({ message: errorMsg });
        }
      });
  });
}